import { render, staticRenderFns } from "./cryptoDetail.vue?vue&type=template&id=53cb434d"
import script from "./cryptoDetail.vue?vue&type=script&lang=js"
export * from "./cryptoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports